module.exports = __webpack_public_path__ + "static/media/manage-apis-1.9c68f67b.png";